export default __webpack_public_path__ + "static/media/step3_act.191f7f97.svg";